import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";

const ConsumableFormModal = (props) => {
    let [edit, setEdit] = useState(false);
    let [deptCode, setDeptCode] = useState();
    let [deptName, setDeptName] = useState();
    let [sizeCode, setSizeCode] = useState();
    let [sizeName, setSizeName] = useState();
    let [consumptionCode, setConsumptionCode] = useState();
    let [consumptionType, setConsumptionType] = useState();
    let [consumableSize, setConsumableSize] = useState();
    const [deptError, setDeptError] = useState(false);
    const [sizeError, setSizeError] = useState(false);
    const [validate, setValidate] = useState(false);
    const [typeError, setTypeError] = useState(false);

    const { t } = useTranslation();
    const formRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (props.data.deptCode) {
            setDeptCode(props?.data?.deptCode);
            setDeptName(props?.data?.deptName);
            setSizeCode(props?.data?.sizeCode);
            setSizeName(props?.data?.sizeName);
            setConsumptionCode(props?.data?.consumptionCode);
            setConsumptionType(props?.data?.consumptionType);
            setConsumableSize(props?.data?.consumableSize);
            setEdit(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSave = (event) => {
        const form = formRef.current;

        if (!deptCode) {
            setDeptError(true);
            return
        } else if (!sizeCode) {
            setSizeError(true);
            return
        } else if (!consumptionType) {
            setTypeError(true);
            return
        }

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setValidate(true);
            return;
        } else {
            setValidate(false);
            const consumableObj = {
                deptCode,
                deptName,
                sizeCode,
                sizeName,
                consumptionCode,
                consumptionType,
                consumableSize,
            };
            if (edit) {
                consumableObj._id = props.data._id;
            }
            props.onSave(consumableObj, edit);
            //   setDeptCode();
            //   setDeptName();
            //   setSizeCode();
            //   setSizeName();
            //   setConsumptionCode();
            //   setConsumptionType();
            //   setConsumableSize();
            setEdit(false);
        }
    };

    const handleCancel = (event) => {
        setDeptCode();
        setDeptName();
        setSizeCode();
        setSizeName();
        setConsumptionCode();
        setConsumptionType();
        setConsumableSize();
        props.onHide();
    };

    let deptList = useSelector(
        (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
    );
    useEffect(() => {
        if (!deptList) {
            dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deptList]);

    const deptResult =
        deptList &&
        deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

    let sizeList = useSelector(
        (state) => state?.masterList?.page[Constants.MASTER.SIZE.name]?.data
    );

    useEffect(() => {
        if (!sizeList) {
            dispatch(fetchMasterList(Constants.MASTER.SIZE));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sizeList]);

    const sizeResult =
        sizeList &&
        sizeList.map(({ sizeCode, sizeName }) => ({ sizeCode, sizeName: `${sizeCode} - ${sizeName}` }));


    let codeNameList = useSelector(
        (state) => state?.masterList?.page[Constants.MASTER.CONSUMPTIONTYPES.name]?.data
    );

    useEffect(() => {
        if (!codeNameList) {
            dispatch(fetchMasterList(Constants.MASTER.CONSUMPTIONTYPES));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codeNameList]);

    const codeTypeResult =
        codeNameList &&
        codeNameList.map(({ consumptionType }) => ({ consumptionType }));


    const { show, onHide } = props;
    return (
        <Modal show={show} onHide={onHide} animation={false} backdrop="static">
            <ModalHeader
                title={edit ? t("msg_master_list.msg_reason.edit_page_title") : t("msg_master_list.msg_reason.page_title")}
            ></ModalHeader>
            <ModalBody>
                <Form noValidate validated={validate} ref={formRef}>
                    <Form.Group className="mb-3">
                        <Form.Label className="col-form-label">
                            {t("msg_master_list.msg_checklist.select_department")}
                        </Form.Label>
                        <DropdownListField
                            id="deptCode"
                            name="deptName"
                            className="dropdownHive w-full rounded-md"
                            data={deptResult}
                            value={deptCode}
                            onChange={(value) => {
                                setDeptCode(value?.deptCode);
                                setDeptName(value?.deptName);
                                setDeptError(false);
                            }
                            }
                            required
                            placeholder={t("msg_master_list.msg_machines.select_department")}
                            autoFocus={true}
                            error={deptError}
                            disabled={!deptResult || edit}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="col-form-label">
                            {t("msg_master_list.msg_consumable.select_size")}
                        </Form.Label>
                        <DropdownListField
                            id="sizeCode"
                            name="sizeName"
                            className="dropdownHive w-full rounded-md"
                            data={sizeResult}
                            value={sizeCode}
                            onChange={(value) => {
                                setSizeCode(value?.sizeCode);
                                setSizeName(value?.sizeName);
                                setSizeError(false);
                            }
                            }
                            required
                            placeholder={t("msg_master_list.msg_consumable.select_size")}
                            autoFocus={true}
                            error={sizeError}
                            disabled={!sizeResult || edit}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label className="col-form-label">
                            {" "}
                            {t("msg_master_list.msg_consumable.select_consumption_code")} :
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={consumptionCode || ""}
                            placeholder="CON001"
                            onChange={(e) => setConsumptionCode(e.target.value)}
                            maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                            disabled={edit}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {t("msg_master_list.msg_consumable.consumableSize_name_validation")}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="col-form-label">
                            {t("msg_master_list.msg_consumable.select_consumption_name")}
                        </Form.Label>
                        <DropdownListField
                            id="consumptionType"
                            name="consumptionType"
                            className="dropdownHive w-full rounded-md"
                            data={codeTypeResult}
                            value={consumptionType}
                            onChange={(value) => {
                                setConsumptionType(value?.consumptionType);
                                setTypeError(false);
                            }
                            }
                            required
                            placeholder={t("msg_master_list.msg_consumable.select_consumption_name")}
                            autoFocus={true}
                            error={typeError}
                            disabled={!codeTypeResult || edit}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label className="col-form-label">
                            {" "}
                            {t("msg_master_list.msg_consumable.ConsumableSize")} :
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={consumableSize || ""}
                            onChange={(e) => setConsumableSize(e.target.value)}
                            maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {t("msg_master_list.msg_consumable.consumableSize_name_validation")}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    variant="success"
                    className="btn btn-success"
                    onClick={handleSave}
                >
                    {t("msg_common.save")}
                </Button>
                <Button
                    type="button"
                    variant="danger"
                    className="btn btn-danger"
                    onClick={handleCancel}
                    data-dismiss="modal"
                >
                    {t("msg_common.cancel")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConsumableFormModal;
